import React, { useMemo } from "react";

interface LightBulbProps {
  color: string;
  delay: number;
}

const LightBulb: React.FC<LightBulbProps> = ({ color, delay }) => {
  return (
    <div
      className="w-3 h-4 rounded-full animate-christmas-twinkle"
      style={{
        backgroundColor: `hsl(${color})`,
        boxShadow: `0 0 10px hsl(${color}), 0 0 20px hsl(${color} / 0.5)`,
        animationDelay: `${delay}s`,
      }}
    />
  );
};

export const ChristmasLights: React.FC = () => {
  const lights = useMemo(() => {
    const colors = [
      "0 80% 50%",      // Red
      "142 76% 36%",    // Green
      "45 93% 47%",     // Gold
      "210 100% 50%",   // Blue
      "300 76% 50%",    // Purple
    ];

    return Array.from({ length: 20 }, (_, i) => ({
      id: i,
      color: colors[i % colors.length],
      delay: (i * 0.15) % 2,
    }));
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-40 pointer-events-none overflow-hidden">
      {/* Wire */}
      <svg
        className="absolute top-0 left-0 w-full h-12"
        viewBox="0 0 1920 48"
        preserveAspectRatio="none"
      >
        <path
          d="M0 8 Q 48 24 96 8 Q 144 -8 192 8 Q 240 24 288 8 Q 336 -8 384 8 Q 432 24 480 8 Q 528 -8 576 8 Q 624 24 672 8 Q 720 -8 768 8 Q 816 24 864 8 Q 912 -8 960 8 Q 1008 24 1056 8 Q 1104 -8 1152 8 Q 1200 24 1248 8 Q 1296 -8 1344 8 Q 1392 24 1440 8 Q 1488 -8 1536 8 Q 1584 24 1632 8 Q 1680 -8 1728 8 Q 1776 24 1824 8 Q 1872 -8 1920 8"
          fill="none"
          stroke="hsl(var(--border))"
          strokeWidth="2"
        />
      </svg>

      {/* Lights */}
      <div className="flex justify-between px-4 pt-4">
        {lights.map((light) => (
          <LightBulb key={light.id} color={light.color} delay={light.delay} />
        ))}
      </div>
    </div>
  );
};

export default ChristmasLights;
